module.exports = __webpack_public_path__ + "static/media/execute_LP.47d0735e.png";